import PropTypes from 'prop-types'
import React from 'react'

import IconInSquare from 'components/IconInSquare'
import { TextLH } from 'styles/components/typography'

import { Wrapper } from './styles'

const ICONS = {
  tube_blue: {
    width: '100%',
    height: '180%',
    top: '-40%',
    left: '0',
  },
  tube_lilac: {
    width: '100%',
    height: '112%',
    top: '-6%',
    left: '0',
  },
  dna: {
    width: '120%',
    height: '120%',
    top: '-10%',
    left: '-10%',
  },
  mobile: {
    width: '130%',
    height: '140%',
    top: '-35%',
    left: '-15%',
  },
}

/**
 * HowItWorksFeature
 *
 * @param {object} props - properties of component
 * @returns {node} HowItWorksFeature
 */
const HowItWorksFeature = props => {
  const { item } = props
  const iconParams = ICONS[item.icon]

  if (!iconParams) {
    return null
  }

  return (
    <Wrapper>
      <figure>
        <IconInSquare
          icon={`color_${item.icon}`}
          iconW={iconParams.width}
          iconH={iconParams.height}
          iconLeft={iconParams.left}
          iconTop={iconParams.top}
        />
        <TextLH
          as="figcaption"
          className="mt-2"
          dangerouslySetInnerHTML={{ __html: item.title }}
        />
      </figure>
    </Wrapper>
  )
}

HowItWorksFeature.propTypes = {
  item: PropTypes.object.isRequired,
}

HowItWorksFeature.defaultProps = {}

export default HowItWorksFeature
